import { render, staticRenderFns } from "./DIYModalCloseButton.vue?vue&type=template&id=10f5f734&scoped=true"
import script from "./DIYModalCloseButton.vue?vue&type=script&lang=js"
export * from "./DIYModalCloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5f734",
  null
  
)

export default component.exports